import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { AlertTriangle, RefreshCw } from 'lucide-react';

const RefundDialog = ({ open, onOpenChange, onConfirm, amount, processing }) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center">
              <AlertTriangle className="h-6 w-6 text-orange-600" />
            </div>
            <AlertDialogTitle className="text-2xl">
              Confirmar Reemborsament
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-base leading-relaxed pt-4">
            <div className="space-y-3">
              <p className="text-foreground font-medium">
                Estàs a punt de reemborsar aquesta comanda.
              </p>
              
              <div className="bg-muted/50 rounded-xl p-4 space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-muted-foreground">Import a reemborsar:</span>
                  <span className="text-xl font-bold text-foreground">{amount}€</span>
                </div>
                <div className="text-sm text-muted-foreground">
                  <p>✓ El client rebrà el reemborsament en 5-10 dies</p>
                  <p>✓ S'enviarà un email de confirmació</p>
                  <p>✓ L'estat de la comanda canviarà a "Reemborsada"</p>
                </div>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-3 mt-4">
                <p className="text-sm text-yellow-800 font-medium flex items-start gap-2">
                  <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
                  <span>Aquesta acció no es pot desfer</span>
                </p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-3 sm:gap-3">
          <AlertDialogCancel 
            disabled={processing}
            className="flex-1"
          >
            Cancel·lar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={processing}
            className="flex-1 bg-orange-600 hover:bg-orange-700"
          >
            {processing ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Processant...
              </>
            ) : (
              <>
                <RefreshCw className="h-4 w-4 mr-2" />
                Reemborsar
              </>
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RefundDialog;
